import { Injectable } from '@angular/core';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { GlobalLearmoModalComponent } from '../partials/global-learmo-modal/global-learmo-modal.component';

import { TemplateRef, Type } from '@angular/core';

export interface LearmoModalOptions extends NgbModalOptions {
  premium?: boolean;
  title?: string;
  icon?: string;
  loading?: boolean;
  footer?: TemplateRef<any> | string | null;
  transparent?: boolean;
  noPadding?: boolean;
  fullHeight?: boolean;
  inputs?: { [key: string]: any };
}

@Injectable({
  providedIn: 'root',
})
export class CustomNgbModalService extends NgbModal {
  open(content: any, options: LearmoModalOptions = {}): NgbModalRef {
    let modalRef: NgbModalRef;

    // Ensure the modal is attached to the body by default to avoid local DOM issues
    if (options.container === undefined) {
      options.container = 'body';
    }

    // Auto-inject premium class if requested or if defaulting to it (optional design choice)
    if (options.premium) {
      const existingClass = options.windowClass || '';
      // Ensure we don't duplicate if already added
      if (!existingClass.includes('premium-modal-window')) {
        options.windowClass = `${existingClass} premium-modal-window`.trim();
      }

      // Override content to be the Global Modal Shell directly
      // We keep the original 'content' to pass it into the shell instance
      const originalContent = content;
      content = GlobalLearmoModalComponent;

      modalRef = super.open(content, options);

      // Pass config to the container
      if (modalRef.componentInstance instanceof GlobalLearmoModalComponent) {
        const instance =
          modalRef.componentInstance as GlobalLearmoModalComponent;
        instance.content = originalContent;
        instance.title = options.title || '';
        instance.iconIcon = options.icon || ''; // Note: input name is iconIcon
        instance.loading = options.loading || false;
        instance.footer = options.footer || null;
        instance.transparent = options.transparent || false;
        instance.noPadding = options.noPadding || false;
        instance.fullHeight = options.fullHeight || false;
        instance.isFullscreen = options.size === 'fullscreen'; // Set fullscreen flag
        instance.componentInputs = options.inputs || {};

        let widthClass = 'w-full';
        if (options.size === 'fullscreen') {
          widthClass = 'w-screen rounded-none shadow-none ring-0';
        }

        instance.widthClass = widthClass;

        // Handle close event from the shell
        instance.closed.subscribe(() => {
          modalRef.dismiss('Cross click');
        });
      }
    } else {
      modalRef = super.open(content, options);
    }

    // Check if modalRef wasn't created yet (legacy path fallback/safety, though we assigned it above)
    // Actually super.open returns a ref. But we can't easily hook into the 'internal' options clone that NgbModal does.
    // So usually we just hook beforeDismiss on the options object PASSED IN.
    // Just returning modalRef is fine.

    return modalRef;
  }
}
